import * as React from 'react';

export interface IDtpStepCompletedProps {
}

export const DtpStepCompleted = (props: IDtpStepCompletedProps) => {
    return (
        <div className={'dtp-portal-card'}>
            <div className="title">
                <span>Request completed</span>
            </div>
            <div className="content">
                <p>
                    Request has been completed and user will be notified about result.
                </p>
            </div>
        </div>
    )
}



// WEBPACK FOOTER //
// ./src/App/dtp-portal/cards/dtp-step-completed.component.tsx